import { PaletteMode } from '@mui/material'
import React, { useContext } from 'react'

export interface ThemeCtx {
  theme: PaletteMode
  setTheme: (theme: PaletteMode) => void
}

export const ThemeContext = React.createContext<null | ThemeCtx>(null)

export const useApplicationTheme = () => {
  const ctx = useContext(ThemeContext)

  if (!ctx) {
    throw new Error('useApplicationTheme must be used within <ThemeProvider />')
  }

  return ctx
}
